import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'
import { STEP_START } from '../../constants';

export const guiTypes = createTypes(['SET_STEP', 'NEXT_STEP', 'PREV_STEP', 'SET_CURRENCY', 'OPEN_MODAL', 'CLOSE_MODAL', 'SET_ACTIVE_CUSTOMER_ID', 'SET_ACTIVE_CONTRACT_TYPE', 'SHOW_STOPPER'], 'GUI');


export const setStep = (step=STEP_START) => {
    return {
        type: guiTypes.SET_STEP,
        step: step,
    };
};

export const nextStep = (offerQueryParams) => {
    return {
        type: guiTypes.NEXT_STEP,
        offerQueryParams: offerQueryParams,
    };
};

export const prevStep = (offerQueryParams) => {
    return {
        type: guiTypes.PREV_STEP,
        offerQueryParams: offerQueryParams,
    };
};

export const setCurrency = (value) => {
    return {
        type: guiTypes.SET_CURRENCY,
        value: value,
    };
};

export const openModal = (id) => {
    return {
        type: guiTypes.OPEN_MODAL,
        id: id,
    };   
}

export const closeModal = (id) => {
    return {
        type: guiTypes.CLOSE_MODAL,
        id: id,
    };   
}

export const setActiveCustomerId = (customerId) => {
    return {
        type: guiTypes.SET_ACTIVE_CUSTOMER_ID,
        customerId: customerId,
    };   
}

export const setActiveContractType = (contractType) => {
    return {
        type: guiTypes.SET_ACTIVE_CONTRACT_TYPE,
        contractType: contractType,
    };   
}

export const showStopper = (isShowStopper, customerId, type='default') => {
    return {
        type: guiTypes.SHOW_STOPPER,
        isShowStopper: isShowStopper,
        showStopperCustomerId: customerId,
        showStopperType: type,
    };
}